import { AccountType } from 'adapters/repositories/typeDefinition';

type functionType = (newAccount:AccountType, prevAccount:AccountType|undefined) => boolean;

export const shouldUpdateAccount:functionType = (newAccount, prevAccount) =>
    !(JSON.stringify(newAccount) === JSON.stringify(prevAccount)) || !prevAccount

